import React from 'react';
import Place from '../components/sections/Place';
import SEO from '../components/SEO';
import { SITE } from '../data/site';

const OndeEstamos: React.FC = () => (
  <>
    <SEO
      title="Onde Estamos | Patinhas Sem Lar"
      description="Conheça a zona de atuação da Patinhas Sem Lar no Porto, Gaia e Norte de Portugal."
      path="/onde-estamos"
    />
    <Place
      locations={SITE.place.locations}
      footnote={SITE.place.footnote}
    />
  </>
);

export default OndeEstamos;
